export default "__VITE_ASSET__BuEBzwWp__"